// University at Albany's undergraduate majors (#2840). Read on 2026-10-01
// from the official 2026-2027 Undergraduate Bulletin's "Majors and Combined
// Bachelor's / Master's Degree Programs" page, whose charts list every major
// by school or college with a Yes or No for the B.A. and the B.S.: a major
// with both appears twice, once per degree. The charts' "Interdisciplinary
// Majors with Concentrations" heading row is not a major and is skipped;
// "RN to B.S. Completion Program" (for registered nurses finishing a
// degree) is left out, as are the combined bachelor's and master's
// programs. One correction: the chart marks Art History as B.S. only, but
// the Department of Art and Art History's bulletin page gives "Bachelors of
// Arts in Art History Requirements", so it is listed as a B.A. Group names
// follow the chart headings ("University-wide" for Interdisciplinary
// Studies). The KB's majors list was the starting point; the bulletin wins.
const majors = {
    "slug": "university-at-albany-suny",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in UAlbany's 2026-2027 Undergraduate Bulletin, grouped by the school or college that offers it, with the degree it leads to. Minors, combined bachelor's and master's programs and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "UAlbany 2026-2027 Undergraduate Bulletin, Majors and Combined Bachelor's / Master's Degree Programs",
                "url": "https://www.albany.edu/undergraduate-bulletin/majors-combined-bachelors-masters.php"
            },
            "majors": [
                {
                    "name": "Actuarial and Mathematical Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Africana Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Art",
                    "degree": "B.S."
                },
                {
                    "name": "Art History",
                    "degree": "B.A."
                },
                {
                    "name": "Atmospheric Science",
                    "degree": "B.S."
                },
                {
                    "name": "Biochemistry & Molecular Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Business Economics",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.A."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Chinese Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Climate Science",
                    "degree": "B.S."
                },
                {
                    "name": "Communication",
                    "degree": "B.A."
                },
                {
                    "name": "Data Science",
                    "degree": "B.S."
                },
                {
                    "name": "East Asian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Geography",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Human Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Documentary Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Globalization Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Legal Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Japanese Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Journalism",
                    "degree": "B.A."
                },
                {
                    "name": "Latin American, Caribbean, and U.S. Latino Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Linguistics",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Quantitative Economics and Data Analysis",
                    "degree": "B.S."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish",
                    "degree": "B.A."
                },
                {
                    "name": "Theatre",
                    "degree": "B.A."
                },
                {
                    "name": "Urban Studies and Planning",
                    "degree": "B.A."
                },
                {
                    "name": "Women's, Gender and Sexuality Studies",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "Massry School of Business",
            "source": {
                "label": "UAlbany 2026-2027 Undergraduate Bulletin, Majors and Combined Bachelor's / Master's Degree Programs",
                "url": "https://www.albany.edu/undergraduate-bulletin/majors-combined-bachelors-masters.php"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "B.S."
                },
                {
                    "name": "Business Administration",
                    "degree": "B.S."
                },
                {
                    "name": "Digital Forensics and Information Security",
                    "degree": "B.S."
                },
                {
                    "name": "Financial Regulation and Technology",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "School of Criminal Justice",
            "source": {
                "label": "UAlbany 2026-2027 Undergraduate Bulletin, Majors and Combined Bachelor's / Master's Degree Programs",
                "url": "https://www.albany.edu/undergraduate-bulletin/majors-combined-bachelors-masters.php"
            },
            "majors": [
                {
                    "name": "Criminal Justice",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "School of Education",
            "source": {
                "label": "UAlbany 2026-2027 Undergraduate Bulletin, Majors and Combined Bachelor's / Master's Degree Programs",
                "url": "https://www.albany.edu/undergraduate-bulletin/majors-combined-bachelors-masters.php"
            },
            "majors": [
                {
                    "name": "Adolescent Education",
                    "degree": "B.S."
                },
                {
                    "name": "Childhood and Special Education",
                    "degree": "B.S."
                },
                {
                    "name": "Early Childhood / Childhood Education",
                    "degree": "B.S."
                },
                {
                    "name": "Human Development",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Emergency Preparedness, Homeland Security and Cybersecurity",
            "source": {
                "label": "UAlbany 2026-2027 Undergraduate Bulletin, Majors and Combined Bachelor's / Master's Degree Programs",
                "url": "https://www.albany.edu/undergraduate-bulletin/majors-combined-bachelors-masters.php"
            },
            "majors": [
                {
                    "name": "Cybersecurity",
                    "degree": "B.S."
                },
                {
                    "name": "Emergency Management and Homeland Security",
                    "degree": "B.S."
                },
                {
                    "name": "Game Design and Development",
                    "degree": "B.S."
                },
                {
                    "name": "Informatics",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Nanotechnology, Science, and Engineering",
            "source": {
                "label": "UAlbany 2026-2027 Undergraduate Bulletin, Majors and Combined Bachelor's / Master's Degree Programs",
                "url": "https://www.albany.edu/undergraduate-bulletin/majors-combined-bachelors-masters.php"
            },
            "majors": [
                {
                    "name": "Computer Science",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Electrical and Computer Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental and Sustainable Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Mechanical and Design Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Mechanical and Mechatronic Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Nanoscale Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Nanoscale Science",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Rockefeller College of Public Affairs and Policy",
            "source": {
                "label": "UAlbany 2026-2027 Undergraduate Bulletin, Majors and Combined Bachelor's / Master's Degree Programs",
                "url": "https://www.albany.edu/undergraduate-bulletin/majors-combined-bachelors-masters.php"
            },
            "majors": [
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Public Policy and Management",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "College of Integrated Health Sciences",
            "source": {
                "label": "UAlbany 2026-2027 Undergraduate Bulletin, Majors and Combined Bachelor's / Master's Degree Programs",
                "url": "https://www.albany.edu/undergraduate-bulletin/majors-combined-bachelors-masters.php"
            },
            "majors": [
                {
                    "name": "Nursing in Partnership with Albany Med Health System",
                    "degree": "B.S."
                },
                {
                    "name": "Nursing 1+2+1 Track in Partnership with St. Peter's Health Partners",
                    "degree": "B.S."
                },
                {
                    "name": "Public Health",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "School of Social Welfare",
            "source": {
                "label": "UAlbany 2026-2027 Undergraduate Bulletin, Majors and Combined Bachelor's / Master's Degree Programs",
                "url": "https://www.albany.edu/undergraduate-bulletin/majors-combined-bachelors-masters.php"
            },
            "majors": [
                {
                    "name": "Social Welfare",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "University-wide",
            "source": {
                "label": "UAlbany 2026-2027 Undergraduate Bulletin, Majors and Combined Bachelor's / Master's Degree Programs",
                "url": "https://www.albany.edu/undergraduate-bulletin/majors-combined-bachelors-masters.php"
            },
            "majors": [
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "B.S."
                }
            ]
        }
    ]
};

export default majors;
